import axios from "axios";
import { logEvent } from "@/utils/logEvent";
import store from "@/store";

const CRUD_METHODS = ["post", "put", "patch", "delete"];

axios.interceptors.response.use(
  async (response) => {
    const method = response.config.method;
    const url = response.config.url;
    // Only log if not a logging API endpoint
    if (CRUD_METHODS.includes(method) && !url.includes("/logs/")) {
      await logEvent({
        action: method,
        feature: url,
        status: "success",
        meta: { data: response.data },
        user: store.state.auth?.user,
      });
    }
    return response;
  },
  async (error) => {
    const method = error.config?.method;
    const url = error.config?.url;
    if (CRUD_METHODS.includes(method) && url && !url.includes("/logs/")) {
      await logEvent({
        action: method,
        feature: url,
        status: "failure",
        meta: { error: error.message },
        user: store.state.auth?.user,
      });
    }
    return Promise.reject(error);
  }
);
